import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import StatusMessage from '../Badge/Statusmessage';

const TimezoneChangeNotification: React.FC = () => {
  const [showNotification, setShowNotification] = useState(false);
  const [initialTimezone] = useState(() => Intl.DateTimeFormat().resolvedOptions().timeZone);

  useEffect(() => {
    const checkTimezone = () => {
      const currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      if (currentTimezone !== initialTimezone) {
        setShowNotification(true);
      }
    };

    // Check timezone every 30 seconds
    const interval = setInterval(checkTimezone, 30000);

    return () => clearInterval(interval);
  }, [initialTimezone]);

  const handleRefresh = () => {
    // Hard reload the page
    window.location.reload();
  };

  const handleClose = () => {
    setShowNotification(false);
  };

  if (!showNotification) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        top: { xs: '70px', sm: '80px', lg: '90px' },
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 1300,
        width: { xs: '95%', sm: '90%', md: '600px' },
        maxWidth: '600px',
      }}
    >
      <StatusMessage
        status="warning"
        message="Your timezone has changed. Please refresh the page to update."
        showIcon={true}
        showButton={true}
        buttonText="Refresh"
        onButtonClick={handleRefresh}
        showCloseButton={true}
        onClose={handleClose}
      />
    </Box>
  );
};

export default TimezoneChangeNotification;
